import { Component, OnInit, OnDestroy } from "@angular/core";

import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "pa-callback",
    templateUrl: "./callback.component.html",
    styleUrls: ["./callback.component.scss"],
    standalone: false
})
export class CallbackComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<void>();

  profile = null;

  constructor(
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.translateService
      .getTranslation(localStorage.getItem("language"))
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        this.navigate();
      });
  }

  navigate() {
    this.router.navigate(["/landing"]);
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
